export default __webpack_public_path__ + "static/media/help-policy-mail.icon.a4d110b9.svg";